export default {

 // BASEURL: "http://127.0.0.1:8000"


  BASEURL: "https://posapi.righttiles.co.uk"





     // BASEURL: "https://devpostiles.dev.techliance.com"
     //  BASEURL: 'http://devpostiles.dev.techliance.co',  ////this one
     // baseURL: 'http://posapi.righttiles.co.uk',
     // baseURL: 'http://devpostiles.dev.techliance.com',




}
